import Select, { components } from 'react-select'
import {useIntl} from 'react-intl';
import {ReactComponent as Dropdown} from 'assets/icons/dropdown.svg';
import {ReactComponent as Chevron} from 'assets/icons/chevron-down.svg';
import {formDataLayerHelper} from 'utils/dataLayerHelper';

const SelectField = ({settings, onChange}) => {
  const intl = useIntl();
  const {
    name,
    placeholder,
    options,
    isMulti = false,
    state,
    label,
    wrapperClasses,
    disabled = false,
    error,
  } = settings || {};
  const dataLayerCallback = formDataLayerHelper(intl, settings);

  if (!name || !options) {
    return '';
  }

  const styles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 50,
    }),
  };

  const handleChange = (value) => {
    if (typeof onChange === 'function') {
      onChange({
        target: {
          name,
          type: 'select',
          value: value
        }
      });
    }
  };

  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        {process.env.REACT_APP_SITE === 'ies' ? <Dropdown /> : <Chevron/>}
      </components.DropdownIndicator>
    );
  };

  return (
    <>
      {process.env.REACT_APP_SITE === 'ies' ?
        <div className={`${wrapperClasses} ${error ? 'form-item--error' : ''}`}>
          {label && <label className="select-label" htmlFor={name}>{intl.formatMessage({id: label})}</label>}
          <Select name={name}
                  options={options}
                  placeholder={intl.formatMessage({id: placeholder})}
                  onChange={(event) => {
                    handleChange(event);
                    if (typeof dataLayerCallback === 'function') {
                      dataLayerCallback(event);
                    }
                  }}
                  components={{
                    DropdownIndicator,
                    IndicatorSeparator: () => null,
                  }}
                  value={state && state[name] ? state[name] : []}
                  className="react-select"
                  classNamePrefix="react-select"
                  isMulti={isMulti}
                  isClearable={false}
                  styles={styles}
                  isDisabled={disabled}
          />
          {error &&
            <span className="form-item__error">
              {intl.formatMessage({id: error})}
            </span>
          }
        </div>
        : <Select name={name}
                  options={options}
                  placeholder={intl.formatMessage({id: placeholder})}
                  onChange={handleChange}
                  components={{
                    DropdownIndicator,
                    IndicatorSeparator: () => null,
                  }}
                  value={state && state[name] ? state[name] : []}
                  className="react-select"
                  classNamePrefix="react-select"
                  isMulti={isMulti}
                  isClearable={false}
                  isDisabled={disabled}
        />
      }
    </>
  )
};

export default SelectField;
